import get from 'lodash/get';
import {
  FETCH_SHIPMENT_TYPE_DETAILS,
  FETCH_SHIPMENT_TYPE_DETAILS_FAILURE,
  FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS,
} from './types';

const initialState = {
  isShipmentTypeLoading: false,
};

const ShipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPMENT_TYPE_DETAILS: {
      return {
        ...state,
        isShipmentTypeLoading: true,
      };
    }

    case FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS: {
      const resData = get(action, 'response', []);
      // resData.rows.sort(function (a, b) {
      //   return b.id - a.id;
      // });
      resData.rows.map((item, i) => {
        item.sno = i + 1;
      });
      return {
        ...state,
        shipmentData: resData.rows,
        shipmentTypesLoading: resData.count,
        isShipmentTypeLoading: false,
      };
    }

    case FETCH_SHIPMENT_TYPE_DETAILS_FAILURE: {
      return {
        ...state,
        isShipmentTypeLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default ShipmentReducer;
